import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { Icon, Loader } from '@fourthwall/components'
import {
  AudioIcon,
  ExclamationMarkIcon,
  PhotoIcon,
  PinIcon,
  PollIcon,
  StreamIcon,
  TypographyIcon,
  VideoIcon,
} from '@fourthwall/icons'

import type { PostType } from '../../../../types'
import * as S from './PostTypeThumbnail.styled'
import type { Props } from './types'

const postIcon: Record<PostType, IconComponent> = {
  Text: TypographyIcon,
  Poll: PollIcon,
  Audio: AudioIcon,
  Video: VideoIcon,
  VideoEmbed: VideoIcon,
  Image: PhotoIcon,
  LiveStream: StreamIcon,
}

export const PostTypeThumbnail = ({ type, thumbnailUrl, resources, pinned }: Props) => {
  const renderThumbnail = () => {
    if (thumbnailUrl) {
      return <S.Thumbnail src={thumbnailUrl} />
    }

    return <Icon component={postIcon[type]} height={24} />
  }

  const renderOverlay = () => {
    if (resources === 'Errored') {
      return (
        <>
          <S.ErrorOverlay />
          <S.ErrorMessage>
            <Icon component={ExclamationMarkIcon} height={13} />
            Error
          </S.ErrorMessage>
        </>
      )
    }

    if (resources === 'Processing') {
      return (
        <>
          <S.ProcessingOverlay />
          <S.ProcessingMessage>
            <Loader size="small" appearance="primary" />
            <div>Processing</div>
          </S.ProcessingMessage>
        </>
      )
    }
  }

  return (
    <S.Container aria-label="Thumbnail">
      {pinned && (
        <S.PinnedBadge>
          <Icon component={PinIcon} height={12} />
        </S.PinnedBadge>
      )}
      {renderThumbnail()}
      {renderOverlay()}
    </S.Container>
  )
}
